import React from "react";
import * as S from "./styles";

const PartnerLink = ({ link, image }: { link: string; image: string }) => {
  const handleClick = () => {
    window.open(link, "_blank");
  };

  return (
    <S.Container onClick={handleClick}>
      {/* 이미지가 백그라운드로 들어가있어서 img태그로 변경 */}
      <img
        src={image}
        alt="로고이미지"
        style={{
          width: "auto",
          height: "20px",
        }}
      />
      {/* <S.PartnerImage image={image} onClick={handleClick} /> */}
    </S.Container>
  );
};

export default PartnerLink;
